import { useEffect, useState } from "react";

export const useStateWithCallback = <T extends any>(
  initialState: T,
  callback: (state: T) => void
) => {
  const [state, setState] = useState(initialState);
  useEffect(() => callback(state), [state]);
  return [state, setState] as const;
};
